import template from './ladda-button.html';
import controller from './ladda-button.controller';

// TODO: Add more classes and effects :3
let laddaButtonComponent = {
  bindings: {
    text: '<',
    laddaDisable: '<',
    stopWhen: '<', // Event signaled from Parent Component when to stop loading
    class: '<',
    load: '<',
    onClick: '&',
  },
  template,
  controller,
};

export default laddaButtonComponent;



// WEBPACK FOOTER //
// ./client/app/shared/ui/ladda-button/ladda-button.component.js